import { BnModalMixin } from '../../common/bn-modal-mixin';
import { html, LitEntity, renderIf } from '../../utility/lit-entity';
import '../../common/bn-loading';
import './bin-move';

class BinMoveModal extends BnModalMixin(LitEntity) {
  constructor() {
    super();
    this.id = 'bin-move-modal';
  }

  renderContents() {
    const beginMove = this.entity && this.entity.getActionByName('begin-move');

    return html`
      <style>
        bn-modal#${this.id} {
          --modal-min-width: 80%;
          --modal-max-width: 80%;
          --modal-body-overflow-y: visible;
          --modal-body-background: var(--gray-10);
        }
        bin-path-name {
          font-size: large;
        }
        .bin-move-container {
          height: 100%;
        }
      </style>

      <h3 slot="title">Move Bin</h3>

      ${renderIf(!beginMove, html`<bn-loading></bn-loading>`)}

      ${renderIf(beginMove, html`
        <div class="bin-move-container">
          <bin-move
            .href="${beginMove.href}"
            .currentbinownerid="${this.getHref('https://api.binsentry.com/rel/owner')}"
            @response="${this._onResponse}"
          ></bin-move>
        </div>
      `)}
    `;
  }

  _onResponse() {
    this.dispatchEvent(new CustomEvent('binmoved'));
    this.close();
  }

  open() {
    this.hide = false;
  }
}

window.customElements.define('bin-move-modal', BinMoveModal);
